import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-idle-warning',
  templateUrl: './idle-warning.component.html',
  styleUrls: ['./idle-warning.component.scss'],
})
export class IdleWarningComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<IdleWarningComponent>) {}

  ngOnInit() {}
}
